import React from 'react'
import { Formik } from 'formik'
import { UseMutateDistributionSubcategoryByIdReturn, distributionSubcategoryNotesByIdDocument, useMutateDistributionSubcategoryById, useDistributionSubcategoryNotesById } from 'src/queries'
import { useInvalidateQueryByDocument } from 'src/hooks/useGraphQL'
import { MutateDistributionSubcategoryByIdMutation } from 'src/gql/graphql'
import Form from './Form'
import parsePlainText from 'src/helpers/parsePlainText'

type Values = Parameters<UseMutateDistributionSubcategoryByIdReturn['mutate']>[0]['record']

interface FormContextProps {
  id: string
  toggle: () => void
}

const FormContext: React.FC<FormContextProps> = (props) => {
  const { id, toggle } = props
  const distributionSubcategory = useDistributionSubcategoryNotesById(id)
  if (distributionSubcategory === undefined) {
    throw new Error('Could not load staffing agency notes!')
  }
  const update = useMutateDistributionSubcategoryById()
  let notes = distributionSubcategory.notes ?? ''
  notes = parsePlainText(notes)
  const initialState: Values = {
    notes
  }
  const invalidateDistributionSubcategory = useInvalidateQueryByDocument(distributionSubcategoryNotesByIdDocument)
  const handleSuccess = (data: MutateDistributionSubcategoryByIdMutation): void => {
    const id = data.cat?.distributionSubcategory?.updateById?.recordId
    if (typeof id === 'string') {
      void invalidateDistributionSubcategory({ id })
    }
    toggle()
  }
  return (
    <Formik
      initialValues={initialState}
      onSubmit={async (data) => {
        const record = { ...data }
        update.mutate({ id, record }, { onSuccess: handleSuccess })
      }}
    >
      {(props) => (
        <>
          <Form toggle={toggle} isLoading={update.isLoading} hasError={update.isError} />
        </>
      )}
    </Formik>
  )
}

export default FormContext
